module.exports = __webpack_public_path__ + "Icono_HistorialCotizaciones_512px.png";